export default {"src":"/_next/static/media/logo-white.c11a4d05.svg","height":100,"width":103,"blurWidth":0,"blurHeight":0};